import React from "react";
import { Link } from "react-router-dom";

function ForgotPassword() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">

      <div className="w-full max-w-md bg-white p-10 rounded-xl shadow-sm">

        <img
          src="/images/logo.png"
          className="m-auto mb-10"
          alt="logo"
          width={200}
        />

        <h1 className="text-3xl text-center font-bold mb-4">
          Forgot Password
        </h1>

        <p className="text-sm text-gray-500 text-center mb-8">
          Enter your email address and we will send you a password reset link.
        </p>

        {/* Email */}
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium">
            Email Address
          </label>
          <input
            type="email"
            placeholder="Enter your email"
            className="border w-full h-10 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* Send Reset Link */}
        <button className="bg-black text-white p-2 w-full rounded-md mb-4">
          Send Reset Link
        </button>

        {/* Back to Login */}
        <div className="text-center text-sm">
          Remember your password?
          <Link to="/login" className="ml-2 font-semibold">
            Back to Login
          </Link>
        </div>

      </div>
    </div>
  );
}

export default ForgotPassword;
